module.exports = ".subtotal {\n  padding-top: 10px; }\n  .subtotal .title {\n    text-transform: uppercase;\n    font-weight: bold; }\n"